export const formatDate = (dateString, withTime = false) => {
  if (!dateString) return "";
  const options = withTime
    ? { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" }
    : { year: "numeric", month: "short", day: "2-digit" };

  return new Date(dateString).toLocaleDateString("en-IN", options);
};

export const generateLeadId = (lastId) => {
  if (!lastId) return "AXE001"; 

  const number = parseInt(lastId.replace(/\D/g, ""), 10) + 1;

  return "AXE" + number.toString().padStart(3, "0");
};

export const ucfirst = (str = "") => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const ucwords = (str = "") => {
  if (!str) return "";
  return str
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};